import { localeToContentStack } from 'src/assets/locale';
import { ApiCallbackType, ContentConfigType } from 'src/types/commonTypes';
import { DOMAIN_PROD, PORTAL_ORIGIN } from 'src/config/constants';

const getContent = async ({
  locale,
  config,
  entryId,
  apiName
}: ContentConfigType): Promise<Response> => {
  const api = config?.apis[apiName];
  let contentApi = api;

  if (
    config.environment === 'production' &&
    window.location.origin === PORTAL_ORIGIN.PROD_CH
  )
    contentApi = api.replace(DOMAIN_PROD.DEFAULT, DOMAIN_PROD.CH);

  const url =
    `${contentApi}?environment=${config.environment}&locale=${locale}`.replace(
      '<ENTRYID>',
      entryId
    );

  return await fetch(url, {
    headers: {
      api_key: config.apiKey,
      access_token: config.accessToken,
      'Content-Type': 'application/json'
    }
  });
};

export const apiCallback = async ({
  entryId,
  apiName,
  config
}: ApiCallbackType): Promise<any> => {
  const locale = window?.Shell?.v1?.localization?.locale?.toLowerCase();
  const resolved = localeToContentStack[locale] || 'en-us';
  const response = await getContent({
    locale: resolved,
    config,
    entryId,
    apiName
  });

  if (response.ok) {
    return response.json();
  }

  if (response.status === 422) {
    const enusResponse = await getContent({
      locale: 'en-us',
      config,
      entryId,
      apiName
    });
    return enusResponse.json();
  }
};
